module.exports = __webpack_public_path__ + "img/send.6d9ce6ca.png";